import React, { useState, useEffect } from 'react';
import { SectionHero, CtaFooter } from '../component';

const RECRUITER_EMAIL = 'nayana@itdatabuild.com';
const JOB_TITLE = 'Technical Project Manager';

const mailtoHref = () => {
    const subject = encodeURIComponent(`Application: ${JOB_TITLE}`);
    const body = encodeURIComponent(
        `Hello Nayanaben,\n\nI am interested in applying for the ${JOB_TITLE} position at ITBUILD Solutions.\n\nPlease find my resume attached to this email. A brief introduction about me:\n\n[Write a short introduction here]\n\nThank you for your consideration.\n\nBest regards,\n[Your Name]\n[Your Phone Number]\n\n--- PLEASE ATTACH YOUR RESUME TO THIS EMAIL BEFORE SENDING ---`
    );
    return `mailto:${RECRUITER_EMAIL}?subject=${subject}&body=${body}`;
};

const jobs = [
    {
        id: 'technical-project-manager',
        title: 'Technical Project Manager',
        location: 'Flower Mound, TX',
        type: 'Full Time · 40 hrs/week · M–F',
    },
];

const CareerPage = () => {
    const [openJobId, setOpenJobId] = useState(null);

    // Lock body scroll when modal is open + allow ESC to close
    useEffect(() => {
        if (!openJobId) return;
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        const onKey = (e) => { if (e.key === 'Escape') setOpenJobId(null); };
        window.addEventListener('keydown', onKey);
        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', onKey);
        };
    }, [openJobId]);

    return (
        <div className='common-wrapper'>
            <SectionHero text="CAREERS" />

            <div className='common-container'>
                <div style={styles.header}>
                    <h2 style={styles.heading}>Open Positions</h2>
                    <p style={styles.subheading}>
                        Join our team and help shape the future of IT solutions.
                    </p>
                </div>

                <div style={styles.jobList}>
                    {jobs.map((job) => (
                        <div key={job.id} style={styles.jobCard}>
                            <div style={styles.jobInfo}>
                                <h3 style={styles.jobTitle}>{job.title}</h3>
                                <div style={styles.jobMeta}>
                                    <span>📍 {job.location}</span>
                                    <span>🕒 {job.type}</span>
                                </div>
                            </div>
                            <button
                                style={styles.applyBtn}
                                onClick={() => setOpenJobId(job.id)}
                            >
                                APPLY
                            </button>
                        </div>
                    ))}
                </div>

                <CtaFooter />
            </div>

            {openJobId === 'technical-project-manager' && (
                <JobModal onClose={() => setOpenJobId(null)} />
            )}
        </div>
    );
};

const JobModal = ({ onClose }) => (
    <div style={styles.overlay} onClick={onClose}>
        <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
                <h3 style={styles.modalTitle}>Technical Project Manager</h3>
                <button style={styles.closeBtn} onClick={onClose} aria-label="Close">×</button>
            </div>

            <div style={styles.modalBody}>
                <p><strong>JOB POSTING DATE:</strong> Friday, 4/10/2026</p>

                <p><strong>JOB TITLE:</strong> Technical Project Manager</p>

                <p><strong>JOB DUTIES:</strong> ITBUILD Solutions has openings for the position of Technical Project Manager, which requires a master's degree in computer science or related, with coursework in computer algorithms, machine learning, data mining, computer networks, data analytics, graphic theory and data science.</p>

                <p><strong>Duties — Project manager responsibilities:</strong></p>
                <ul style={styles.ul}>
                    <li>Develop and maintain project plans, including schedules, budgets, and resource allocation.</li>
                    <li>Conduct performance reviews and support career development goals of team members.</li>
                    <li>Implement project management methodologies, such as Agile or Scrum, tailored to the team's needs and the project's requirements.</li>
                    <li>Provide technical leadership in data architecture, data modeling, data integration, and data warehousing.</li>
                    <li>Ensure the quality and reliability of the data solutions delivered by the team.</li>
                </ul>

                <p>Full time – 40 hrs/week. M–F. Job Location: Flower Mound, Texas. Must be authorized to work in the United States. Mail resumes to Nayanaben at ITBUILD Solutions, 2201 Spinks Rd Suite 216, Flower Mound, TX 75022, or email resumes to <a href={`mailto:${RECRUITER_EMAIL}`}>{RECRUITER_EMAIL}</a>.</p>

                <p><strong>REQUIREMENTS:</strong></p>
                <ul style={styles.ul}>
                    <li><strong>Education:</strong> Master's degree in Computer Science or related field</li>
                    <li><strong>Salary:</strong> $80,142 / year</li>
                    <li><strong>Location:</strong> Flower Mound, TX</li>
                </ul>

                <p>Any applicant who is interested in this position may apply to the following individual for consideration: <strong>Nayanaben Kapadia</strong> — <a href={`mailto:${RECRUITER_EMAIL}`}>{RECRUITER_EMAIL}</a></p>
            </div>

            <div style={styles.modalFooter}>
                <a href={mailtoHref()} style={styles.applyBtnModal}>
                    APPLY
                </a>
            </div>
        </div>
    </div>
);

const styles = {
    header: { textAlign: 'center', margin: '2rem 0 3rem' },
    heading: { fontSize: '2rem', marginBottom: '0.5rem' },
    subheading: { color: '#666', fontSize: '1rem' },
    jobList: { display: 'flex', flexDirection: 'column', gap: '1rem', maxWidth: '900px', margin: '0 auto 4rem' },
    jobCard: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1rem',
        padding: '1.5rem 2rem',
        border: '1px solid #e5e5e5',
        borderRadius: '12px',
        background: '#fff',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        flexWrap: 'wrap',
    },
    jobInfo: { flex: 1, minWidth: '200px' },
    jobTitle: { margin: 0, fontSize: '1.25rem', fontWeight: 600 },
    jobMeta: { display: 'flex', gap: '1.5rem', marginTop: '0.5rem', color: '#666', fontSize: '0.9rem', flexWrap: 'wrap' },
    applyBtn: {
        padding: '0.75rem 2rem',
        background: '#0a2540',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        fontWeight: 600,
        letterSpacing: '0.05em',
        cursor: 'pointer',
        fontSize: '0.9rem',
    },
    overlay: {
        position: 'fixed', inset: 0,
        background: 'rgba(0,0,0,0.6)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 9999, padding: '1rem',
    },
    modal: {
        background: '#fff',
        borderRadius: '12px',
        maxWidth: '720px',
        width: '100%',
        maxHeight: '90vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    },
    modalHeader: {
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '1.25rem 1.5rem', borderBottom: '1px solid #eee',
    },
    modalTitle: { margin: 0, fontSize: '1.25rem' },
    closeBtn: {
        background: 'transparent', border: 'none', fontSize: '2rem',
        lineHeight: 1, cursor: 'pointer', color: '#666', padding: 0, width: '2rem', height: '2rem',
    },
    modalBody: {
        padding: '1.5rem', overflowY: 'auto', flex: 1,
        fontSize: '0.95rem', lineHeight: 1.6, color: '#333',
    },
    sectionHeading: { marginTop: 0, fontSize: '1rem', letterSpacing: '0.05em' },
    ul: { paddingLeft: '1.25rem', marginTop: '0.5rem' },
    legal: { fontSize: '0.85rem', color: '#555', background: '#f7f7f7', padding: '0.75rem', borderRadius: '6px' },
    modalFooter: {
        padding: '1rem 1.5rem', borderTop: '1px solid #eee',
        display: 'flex', justifyContent: 'flex-end', background: '#fafafa',
    },
    applyBtnModal: {
        padding: '0.85rem 2.5rem', background: '#0a2540', color: '#fff',
        textDecoration: 'none', borderRadius: '8px', fontWeight: 600,
        letterSpacing: '0.05em', fontSize: '0.95rem', display: 'inline-block',
    },
};

export default CareerPage;